/* WE LOVE MUSIC – Kollektions-Filter. Initialisiert jede .ui-acv Section: Artist-Popup+Suche, Produktart-Dropdown, Sortierung, Lazy-Reveal in Batches. */
(function(){
  function init(acv){
    if(!acv || acv.dataset.acvReady) return;
    acv.dataset.acvReady = '1';
    var grid = acv.querySelector('[data-acv-grid]');
    if(!grid) return;
    var sentinel = acv.querySelector('[data-acv-sentinel]');
    var batch = parseInt(acv.getAttribute('data-acv-batch'),10) || 12;
    var state = {};
    var revealed = batch;
    function items(){ return Array.prototype.slice.call(grid.querySelectorAll('.acv__item')); }
    function filterActive(){ for(var g in state){ if(state[g] && state[g] !== '*') return true; } return false; }
    function matches(it){
      for(var g in state){ var val = state[g]; if(!val || val === '*') continue;
        if(g === 'tags'){ if((it.getAttribute('data-tags')||'').indexOf('|'+val+'|') === -1) return false; }
        else { if(it.getAttribute('data-'+g) !== val) return false; }
      }
      return true;
    }
    function apply(){
      var active = filterActive();
      var shown = 0;
      items().forEach(function(it){
        var m = matches(it);
        var vis;
        if(!m){ vis = false; }
        else if(active){ vis = true; }
        else { vis = shown < revealed; }
        if(m) shown++;
        it.classList.toggle('is-hidden', !vis);
      });
      if(sentinel){ sentinel.style.display = (!active && revealed < shown) ? 'block' : 'none'; }
    }
    var artistWrap = acv.querySelector('[data-acv-artist]');
    if(artistWrap){
      var toggle = artistWrap.querySelector('[data-acv-artist-toggle]');
      var pop = artistWrap.querySelector('[data-acv-artist-pop]');
      var label = artistWrap.querySelector('[data-acv-artist-label]');
      var search = artistWrap.querySelector('[data-acv-artist-search]');
      var empty = artistWrap.querySelector('[data-acv-artist-empty]');
      var opts = Array.prototype.slice.call(artistWrap.querySelectorAll('.acv__opt'));
      var defLabel = label.textContent;
      function filterOpts(q){
        q = (q||'').trim().toLowerCase(); var any = false;
        opts.forEach(function(o){ if(o.dataset.filter === '*'){ o.classList.toggle('is-hidden', q !== ''); return; }
          var hit = (o.dataset.name||'').indexOf(q) !== -1; o.classList.toggle('is-hidden', !hit); if(hit) any = true; });
        if(empty){ empty.hidden = any || q === ''; }
      }
      function openPop(o){ pop.hidden = !o; toggle.setAttribute('aria-expanded', o?'true':'false'); if(o){ search.value=''; filterOpts(''); search.focus(); } }
      toggle.addEventListener('click', function(e){ e.stopPropagation(); openPop(pop.hidden); });
      search.addEventListener('input', function(){ filterOpts(search.value); });
      opts.forEach(function(o){ o.addEventListener('click', function(){
        opts.forEach(function(x){ x.classList.remove('is-active'); }); o.classList.add('is-active');
        state.vendor = o.dataset.filter;
        var isAll = o.dataset.filter === '*';
        label.textContent = isAll ? defLabel : o.textContent;
        toggle.classList.toggle('is-set', !isAll);
        openPop(false); apply();
      }); });
      document.addEventListener('click', function(e){ if(!pop.hidden && !artistWrap.contains(e.target)){ openPop(false); } });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !pop.hidden){ openPop(false); toggle.focus(); } });
    }
    var ptypeSel = acv.querySelector('[data-acv-ptype]');
    if(ptypeSel){ ptypeSel.addEventListener('change', function(){ state.tags = ptypeSel.value; apply(); }); }
    var sortSel = acv.querySelector('[data-acv-sort]');
    function applySort(){ if(!sortSel) return; var v = sortSel.value; var arr = items();
      arr.sort(function(a,b){
        if(v === 'date-asc') return (a.dataset.date||0) - (b.dataset.date||0);
        if(v === 'price-asc') return (a.dataset.price||0) - (b.dataset.price||0);
        if(v === 'price-desc') return (b.dataset.price||0) - (a.dataset.price||0);
        if(v === 'title-asc') return (a.dataset.title||'').localeCompare(b.dataset.title||'');
        return (b.dataset.date||0) - (a.dataset.date||0);
      });
      arr.forEach(function(it){ grid.appendChild(it); }); if(sentinel) grid.parentNode.appendChild(sentinel); apply();
    }
    if(sortSel){ sortSel.addEventListener('change', applySort); }
    function revealMore(){ if(filterActive()) return; var total = items().length; if(revealed < total){ revealed += batch; apply(); return true; } return false; }
    if(sentinel && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ revealMore(); } }); }, { rootMargin: '400px 0px' });
      io.observe(sentinel);
    }
    // Scroll-Fallback (falls IntersectionObserver/Viewport nicht greift)
    var ticking = false;
    window.addEventListener('scroll', function(){
      if(ticking) return; ticking = true;
      requestAnimationFrame(function(){
        ticking = false;
        if(filterActive() || !sentinel) return;
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var top = sentinel.getBoundingClientRect().top;
        if(vh === 0 || top <= vh + 600){ revealMore(); }
      });
    }, { passive: true });
    apply();
  }
  function initAll(scope){ (scope||document).querySelectorAll('.ui-acv').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ initAll(); }); } else { initAll(); }
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();
